<template>
    <v-layout align-end wrap>
        <v-flex>
            <v-layout column align-end>
                <v-switch
                    @change="onChanged"
                    class="text-caption"
                    v-model="autoRefresh"
                    label="AUTO REFRESH"
                    color="info"
                    dense>
                </v-switch>       
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>

    let refresh = null

    export default {
        name: 'AutoRefresh',
        props: [],        
        mounted: function () {
            this.turnOn();
        },
        computed: {
        },
        watch: {
        },        
        methods: {
            turnOn: function() {
                refresh = setInterval(() => {
                    this.$emit('onRefresh')
                }, 60000);
            },
            turnOff: function() {
                clearInterval(refresh);
            },
            onChanged: function(value) {
                if (value) {
                    this.turnOn()
                } else {
                    this.turnOff()
                }
            }
        },
        data: function() {
            return {
                autoRefresh: true
            }
        },    
    }
</script>

<style scoped lang="scss">

</style>